// ProvVakt's poll pace (ProvVakt.tsx), as a pure function so it can be tested.
//
//  - A started pass is named: the running-prov pace.
//  - On a prov page (/prov-elev/<pass>, not its result page): the running-prov pace while a pass
//    was named in the last PROVSIDA_FONSTER_MS, or the page was opened in it. Right after a start
//    the shared "who can have a pass" set can still say "none" for up to its TTL, and the idle
//    pace would then delay the teacher's close by half a minute; a student who handed in and
//    waits on the page falls back to the idle pace.
//  - Otherwise the idle pace.
import { PROVSIDA_FONSTER_MS, PROVVAKT_AKTIVT_PASS_MS, PROVVAKT_MS } from "@/lib/klient-intervall";

export function arProvsida(sida: string): boolean {
  return sida.startsWith("/prov-elev/") && !sida.endsWith("/resultat");
}

export function provvaktTakt(l: {
  sida: string;
  nu: number;
  /** The answer named a started pass. */
  aktivt: boolean;
  /** When an answer last named a pass (started or opened), 0 for never. */
  passNamndVid: number;
  /** When the current page was opened. */
  sidaOppnadVid: number;
}): number {
  if (l.aktivt) return PROVVAKT_AKTIVT_PASS_MS;
  if (arProvsida(l.sida) && l.nu - Math.max(l.passNamndVid, l.sidaOppnadVid) < PROVSIDA_FONSTER_MS) {
    return PROVVAKT_AKTIVT_PASS_MS;
  }
  return PROVVAKT_MS;
}
